module.exports = __webpack_public_path__ + "static/img/hero_shape_1.6c7560d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero_shape_1.png
// module id = hX9M
// module chunks = 0